import { render, staticRenderFns } from "./SidebarDebtCollectionDetail.vue?vue&type=template&id=7c24ac76&"
import script from "./SidebarDebtCollectionDetail.vue?vue&type=script&lang=js&"
export * from "./SidebarDebtCollectionDetail.vue?vue&type=script&lang=js&"
import style0 from "./SidebarDebtCollectionDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports